import React from 'react';
import styled from 'styled-components';
import Rating from '@catalogo/ui-americanas-mobile-rating';
import { formatPrice } from '@catalogo/core-helpers/price';
import { FormCheckbox } from '@catalogo/theme-form-builder/src/components/checkbox';
import { IProductCard, IStyle } from '../helpers/interfaces';
import { onClick } from '../helpers/functions';

export const ProductCard: React.FC<IProductCard> = props => {
  const { image, name, salesPrice, sku, sellerId, isSelected, handleClick, id, condition, rating, first } = props;
  const url = `https://www.americanas.com.br/produto/${id}?pfm_type=vit_recommendation&pfm_page=product&pfm_carac=compre_junto`;

  return (
    <OtherProductsContainer first={first}>
      <CheckboxContainer isSelected={isSelected}>
        <FormCheckbox
          checked={isSelected}
          onClick={onClick(sku, sellerId, salesPrice, isSelected, id, condition, handleClick)}
        />
      </CheckboxContainer>
      <ImageBox>
        <ComboImg alt={name} src={image} />
      </ImageBox>
      <InfoBox>
        <ProductName href={url} target="_blank">
          {name}
        </ProductName>
        <RatingUI rating={rating} size={14} />
        <PriceUI>R$ {formatPrice(salesPrice)}</PriceUI>
      </InfoBox>
    </OtherProductsContainer>
  );
};

const OtherProductsContainer = styled.div<IStyle>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${({ first }) => (first ? '17px' : '0px')};
  padding: 0 20px;
  max-width: 100%;

  img {
    width: 100%;
  }

  @media screen and (max-width: 480px) {
    min-height: 76px;
  }
`;

const CheckboxContainer = styled.div<IStyle>`
  & > div {
    border-radius: 6px;
    border: 2px solid ${({ theme, isSelected }) => (isSelected ? theme.primaryColor : theme.grey.medium)};
    width: 20px;
    height: 20px;
    padding: 3px;
  }
`;

const ComboImg = styled.img`
  margin: 0 10px;
  width: 100px;
  max-width: -webkit-fill-available;
`;

const ProductName = styled.a`
  margin-bottom: 5px;
  font-size: 14px;
  color: ${({ theme }) => theme.grey.dark};
  font-weight: normal;
  font-family: 'Hind Madurai', sans-serif;
  overflow: hidden;
  padding: 0px;
  text-decoration: underline;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
`;

const PriceUI = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.black};
`;

const RatingUI = styled(Rating)`
  justify-content: start;
`;

const ImageBox = styled.div`
  width: 34%;
`;

const InfoBox = styled.div`
  width: 65%;
`;

export default ProductCard;
